/* eslint-disable no-unused-vars */
import React from "react";
import { graphql, navigate } from "gatsby";
import Layout from "../components/layout";
import { Section, Sections, IPage } from "../interfaces";
import SEO from "../components/seo";
import SectionBroker from "../components/brokers/section-broker";
import { getSiteClassName } from "../utils";
import { Helmet } from "react-helmet";
import { login, isAuthenticated, isAuthorized, getProfile, authEnabled } from "../utils/auth";
import { convertToHumanReadable, groupSectionsByComponentType } from "../utils";
export default class PostPage extends React.Component {
  trimmedPageName: string;
  siteClassName: string;
  protectedPath: boolean;

  constructor(props) {
    super(props);
  }

  componentDidMount() {
    if (authEnabled() && (this.props["path"] || "").match(/^\/secure/)) {
      console.warn("Page is secure");
      if (!isAuthenticated()) {
        console.warn("User not authenticated.");
        login();
        return <p>Redirecting to login...</p>;
      } else if (!isAuthorized()) {
        console.warn("User not authorized to access this resource.");
        navigate("/");
        return <p>Access denied...</p>;
      }
    }
  }

  preventPageSEOIndexing() {
    const { search_engine_visibility } = this.props.data.cms.post;
    if (search_engine_visibility === "public" || search_engine_visibility == null) return null;
    return (
      <Helmet>
        <meta name="robots" content="noindex" />
      </Helmet>
    );
  }

  render() {
    const {
      attributes: {
        site,
        seo_description,
        seo_title,
        header,
        footer,
        id,
        sections,
        categories,
        tags
      }
    }: any = this.props.data.cms.post.data;

    const seoCategory = categories.data[0]?.attributes?.name;

    const sectionGroups = groupSectionsByComponentType(sections);
    this.siteClassName = getSiteClassName(site);
    const user = getProfile();
    const seoTitle = seoCategory
      ? `${convertToHumanReadable(seoCategory)} - ${seo_title}`
      : seo_title;

    return (
      <Layout header={header} footer={footer} site={site} user={user}>
        <>
          <SEO
            site={site}
            description={seo_description}
            lang="en"
            title={seoTitle}
            bodyId={this.siteClassName}
          />
          {this.preventPageSEOIndexing()}
          <div
            className={`page-sections page category-${
              seoCategory != null ? seoCategory : "default"
            }`}
          >
            {(sectionGroups || []).map((el, i) => {
              const components = Array.isArray(el) ? el : [el];
              const componentType = components[0].__typename || components[0].component;

              return (
                <div key={`section-group-${i}`} className={`section-${componentType}`}>
                  {(components || []).map((section: Sections, index: number) => {
                    return (
                      <SectionBroker section={section as Section} key={`${index}-${section.id}`} />
                    );
                  })}
                </div>
              );
            })}
          </div>
        </>
      </Layout>
    );
  }
}

export const query = graphql`
  query PostPageQuery($id: ID) {
    cms {
      post(id: $id) {
        data {
          ...PostAttributes
        }
      }
    }
  }
`;
